import { ChangeEvent, ChangeEventHandler, forwardRef, memo, useCallback } from "react";
import { InputContainer, InputContainerProps } from "../InputContainer";

export type TextFieldProps = Omit<InputContainerProps, "inputComponent" | "onChange" | "value"> & {
  onChange?: (value: string | null, e?: ChangeEvent<HTMLInputElement> | null) => void,
  value?: string | null
}

export const TextField = memo(forwardRef<HTMLInputElement, TextFieldProps>((
  {
    onChange,
    value,
    ...props
  }, ref,
) => {
  const wrappedOnChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => onChange?.(e?.target?.value || null, e),
    [ onChange ],
  );
  return (
    <InputContainer
      value={value || ""}
      ref={ref}
      inputComponent="input"
      type="text"
      {...props}
      onChange={wrappedOnChange}
    />
  );
}));